<template>
    <div></div>
</template>

<script>
    import axios from '@/plugins/axios-silent';

    export default {
        name: 'SurveyFromListTrigger',
        props: {
            canOpen: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                timeoutId: null
            };
        },
        watch: {
            canOpen(val) {
                if (!val) {
                    return;
                }
                this.tryShowSurveyFromList();
            }
        },
        methods: {
            async tryShowSurveyFromList() {
                const sheet = this?.$f7?.sheet?.get();
                if (sheet?.opened) {
                    this.$emit('waiting');
                    return;
                }
                const popup = this?.$f7?.popup?.get('.survey-flow');
                if (popup?.opened) {
                    this.$emit('waiting');
                    return;
                }
                try {
                    const { data } = await axios.get('/front/surveys');
                    if (data && data.length > 0) {
                        this.$emit('processing', true);
                        this.$root.$emit('surveyFlowStart', data[0]);
                    } else {
                        this.$emit('waiting');
                    }
                } catch (e) {
                    this.$emit('waiting');
                }
            }
        }
    };
</script>
